/*
* @Author: gujianghua
* @Date:   2019-12-23 14:03:56
* @Last Modified by:   gujianghua
* @Last Modified time: 2019-12-23 18:18:57
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
const v2 = BASE_API

export default {
	getList(data) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/contentPageList',
			method: 'get',
			params: data
		})
	},
	createContent(data) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/createContent',
			method: 'post',
			data: data
		})		
	},
	deleteContent(data) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/deleteContent',
			method: 'post',
			params: data
		})		
	},
	findContentById(data) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/findContentById',
			method: 'get',
			params: data
		})		
	},
	modifyContent(data) {
		return service({
			url: '/cloud/course/v1/admin/coursesource/modifyContent',
			method: 'post',
			data: data
		})		
	}
}


// WEBPACK FOOTER //
// ./src/api/contentManage/voicesource.js